import React from 'react';
import MemberBoard from './memberBoard';

const MembersPage : React.FC = () => (
  <div>
    <MemberBoard />
  </div>
);

export default MembersPage;
